var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header-box" }, [
    _c(
      "div",
      { staticClass: "header-wrap" },
      [
        _c("a", {
          staticClass: "logo",
          attrs: { href: "https://sos.kingsgroupgames.com", target: "_blank" },
        }),
        _c(
          "div",
          { staticClass: "right-box" },
          [
            _c("PwaPrompt"),
            _c("PwaPromptSafari"),
            _c(
              "a",
              {
                staticClass: "btn btn-header btn-install-pc",
                attrs: { href: "javascript:;" },
                on: { click: _vm.toInstallPC },
              },
              [_c("span", { staticClass: "btn-header-icon" }), _vm._m(0)]
            ),
            _c(
              "div",
              {
                staticClass: "btn btn-header entrance-wrapper",
                class: { active: _vm.userInfo.openid },
                on: {
                  click: function ($event) {
                    _vm.isShowWelfareCenter = true
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "btn-header-icon award",
                  class: { rotate: _vm.userInfo.openid },
                }),
                _c("div", { staticClass: "btn-header-content" }, [
                  _vm._v(" " + _vm._s(_vm.$t("boon-page-title")) + " "),
                ]),
              ]
            ),
            _c(
              "a",
              {
                staticClass: "btn btn-header btn-recharge",
                class: { active: _vm.userInfo.openid },
                attrs: { href: "javascript:;" },
                on: { click: _vm.toStore },
              },
              [
                _c("span", { staticClass: "btn-header-icon" }),
                _vm.isFirstPay
                  ? _c("div", { staticClass: "discount" })
                  : _vm._e(),
                _c("div", { staticClass: "btn-header-content" }, [
                  _vm._v(" " + _vm._s(_vm.$t("btn-header-recharge")) + " "),
                ]),
              ]
            ),
            _c(
              "a",
              {
                staticClass: "btn btn-header css-btn",
                class: {
                  active: _vm.userInfo.uid && _vm.configJson && _vm.messageJson,
                },
                attrs: { href: "javascript:;" },
                on: { click: _vm.openFaq },
              },
              [
                _c("span", { staticClass: "btn-header-icon" }),
                _c("div", { staticClass: "btn-header-content" }, [
                  _vm._v(" " + _vm._s(_vm.$t("text_css_btn")) + " "),
                ]),
              ]
            ),
            _c(
              "a",
              {
                staticClass: "btn btn-header btn-header-s btn-mute",
                class: { mute: _vm.isMute, hide: !_vm.showMuteBtn },
                attrs: { href: "javascript:;" },
                on: { click: _vm.muteControl },
              },
              [_c("span", { staticClass: "btn-header-icon" })]
            ),
            _c("div", { staticClass: "tools-wrap" }, [
              _c("div", { staticClass: "login-box" }, [
                _c("div", { staticClass: "avatar" }),
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.userInfo.name)),
                ]),
                _c("em", { staticClass: "icon-arrow-down" }),
                _c("div", { staticClass: "menu" }, [
                  _c(
                    "a",
                    {
                      staticClass: "menu-item bind-account",
                      attrs: { href: "javascript:;" },
                      on: { click: _vm.onBindAccountClick },
                    },
                    [_vm._v(_vm._s(_vm.$t("lLinkAccount")))]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "menu-item change-account",
                      attrs: { href: "javascript:;" },
                      on: { click: _vm.changeAccount },
                    },
                    [_vm._v(_vm._s(_vm.$t("lSwitchAccount")))]
                  ),
                  _vm.loginType === "account"
                    ? _c(
                        "a",
                        {
                          staticClass: "menu-item change-account",
                          attrs: { href: "javascript:;" },
                          on: { click: _vm.logout },
                        },
                        [_vm._v(_vm._s(_vm.$t("lLogout")))]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ],
          1
        ),
        _vm.showPopup === "login"
          ? _c("Login", {
              attrs: { data: _vm.dataPopup },
              on: { changePopup: _vm.changePopup },
            })
          : _vm.showPopup === "Verify"
          ? _c("Verify", {
              attrs: { data: _vm.dataPopup },
              on: { changePopup: _vm.changePopup },
            })
          : _vm.showPopup === "Result"
          ? _c("Result", {
              attrs: { data: _vm.dataPopup },
              on: {
                changePopup: _vm.changePopup,
                loginComplete: _vm.loginComplete,
                localLogin: _vm.doVisitorLogin,
              },
            })
          : _vm._e(),
        _vm.showPopup === "bind"
          ? _c("Account", { on: { changePopup: _vm.changePopup } })
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { ref: "welfareCenter", staticClass: "welfare-wrapper" },
      [
        _vm.isShowWelfareCenter
          ? _c("WelfareCenter", {
              on: {
                close: function ($event) {
                  _vm.isShowWelfareCenter = false
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "btn-header-content" }, [
      _c("div", { staticClass: "t" }, [_vm._v("PLAY ON PC")]),
      _c("div", { staticClass: "b" }, [_vm._v("ONLY FOR WINDOWS")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }